import type {
  CreditConfirmation,
  CreditConfirmationResponse,
  CreditCostQuote,
  CreditCostQuoteResponse,
  CreditCostRequest,
} from '../types';

export const mapCreditCostQuote = (data: CreditCostQuoteResponse): CreditCostQuote => ({
  operation: data.operation,
  creditsEnabled: data.credits_enabled,
  credits: data.credits,
  balance: data.balance,
  balanceAfter: data.balance_after,
  canCover: data.can_cover,
  shortage: data.shortage,
  items: data.items.map((item) => ({
    contentId: item.content_id,
    title: item.title,
    mediaType: item.media_type,
    durationSeconds: item.duration_seconds,
    localeCodes: item.locale_codes,
    credits: item.credits,
  })),
});

export const mapCreditConfirmation = (data: CreditConfirmationResponse): CreditConfirmation => ({
  ...mapCreditCostQuote(data),
  id: data.id,
  expiresAt: data.expires_at,
});

// The request as the server reads it: snake_case, one value or a list per key.
export const toCreditCostRequestPayload = (request: CreditCostRequest): Record<string, string | string[]> => {
  switch (request.operation) {
    case 'translation':
      return { operation: request.operation, content_id: request.contentId, locale: request.locale };
    case 'retranslation':
      return {
        operation: request.operation,
        content_ids: request.contentIds ?? [],
        content_series_ids: request.contentSeriesIds ?? [],
        locale_codes: request.localeCodes ?? [],
      };
    case 'series_translation':
      return { operation: request.operation, content_series_id: request.contentSeriesId, locale: request.locale };
    case 'reel_rerender':
      return { operation: request.operation, social_clip_id: request.clipId };
    default:
      return { operation: request.operation, content_id: request.contentId };
  }
};
